import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as SettingsActionCreators from '../../../actions/settings';

class MessageMethod extends React.Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    selectedMethod: '',
  }


  /**
   * Component did mount
   * @return {undefined}
   */
  componentWillMount = () => {
    this.setState({
      selectedMethod: this.props.data.messageViaNetwork,
    });
  }


  /**
   * Handle submit
   * @param  {Object} e
   * @return {undefined}
   */
  handleSubmit = (e) => {
    e.preventDefault();

    const selectedMethod = this.state.selectedMethod;

    if (!selectedMethod) {
      return;
    }

    this.props.dispatch(SettingsActionCreators.saveMessageVia(selectedMethod));
  }


  /**
   * Handle change
   * @param  {Object} e
   * @return {undefined}
   */
  handleChange = (e) => {
    this.setState({
      selectedMethod: e.target.value,
    });
  }


  /**
   * Render
   * @return {JSX}
   */
  render() {
    const { isChangingVia, data } = this.props;

    return (
      <div>
        <h2 className="heading heading--2">How should we message you?</h2>
        <form onSubmit={this.handleSubmit}>
          <ul>
            <li className="radio">
              <label>
                <input name="messageVia" type="radio" value="Email" onChange={this.handleChange} checked={this.state.selectedMethod === 'Email'} />
                {' '}
Email
              </label>
            </li>
            { data.facebookAuth ? (
              <li className="radio">
                <label>
                  <input name="messageVia" type="radio" value="Facebook" onChange={this.handleChange} checked={this.state.selectedMethod === 'Facebook'} />
                  {' '}
Facebook
                </label>
              </li>
            ) : null }
            { data.twitterAuth ? (
              <li className="radio">
                <label>
                  <input name="messageVia" type="radio" value="Twitter" onChange={this.handleChange} checked={this.state.selectedMethod === 'Twitter'} />
                  {' '}
Twitter
                </label>
              </li>
            ) : null }
          </ul>
          <p><button className="button button--primary" disabled={!this.state.selectedMethod}>{ isChangingVia ? 'Saving...' : 'Update' }</button></p>
        </form>
      </div>
    );
  }
}


const mapStateToProps = state => (
  {
    isChangingVia: state.settings.isChangingVia,
    message: state.settings.message,
    isSuccess: state.settings.isSuccess,
    data: state.settings.data,
  }
);

export default withRouter(connect(mapStateToProps)(MessageMethod));
